import styled from '@emotion/styled';
import Autocomplete from '@mui/material/Autocomplete';

export const StyledAutocomplete = styled(Autocomplete)`
  .MuiAutocomplete-input {
    color: ${({ theme }) => theme.colors.neutral.shades.shade700};
    padding-right: 0;
    ::placeholder {
      opacity: 1;
    }
  }
    .MuiOutlinedInput-root {
    padding-right: 16px !important;

    }
  .MuiSvgIcon-root {
    display: none;
  }
  .MuiButtonBase-root {
    display: none;
  }
  .Mui-disabled {
    .MuiInputBase-input {
      border: none;
    }
  }

  .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
    -webkit-text-fill-color: ${({ theme }) => theme.colors.neutral.shades.shade300};
  }
`;
